export const DATA_LIMIT = 10;

export const DESIGN_INFO_IDS = {
    ALL_DESIGNS: "all-designs",
};

export const DESIGN_INFO_KEYS = {
    DESIGN_INFO_FILTERS: 'design-info.filters',
    PRODUCTS_LIST_FILTERS: 'product-list.filters',
    DESIGN_PRODUCT_IMAGES_FILTERS: 'design-product-images.filters',
};

export const DESIGN_INFO_FIELDS_LIST: any = [
    {attribute: "productType", label: "Product Type", cssClass: ''},
    {attribute: "category", label: "Category", cssClass: ''},
    {attribute: "name", label: "Name", cssClass: ''},
    /*{attribute: "parent", label: "Parent", cssClass: ''},
    {attribute: "quoteName", label: "Quote Name", cssClass: 'text-center'},
    {attribute: "themeName", label: "Theme Name", cssClass: 'text-center'},*/
    /*{attribute: "totalVariants", label: "Total Variants", cssClass: 'text-center'},*/
    {attribute: "totalProducts", label: "Total Products", cssClass: 'text-center'},
    {
        attribute: "hasBlogPost", label: "Has Blog Post", cssClass: 'text-center', isBoolean: true,
        highlightValues: ['No'],
    },
    {
        attribute: "hasContent", label: "Has Content", cssClass: 'text-center', isBoolean: true,
        highlightValues: ['No'],
    },
    {
        attribute: "hasDuplicateMetaTitle",
        label: "Has Duplicate Meta Title",
        cssClass: 'text-center',
        isBoolean: true,
        highlightValues: ['Yes']
    },
    {
        attribute: "hasTags", label: "Has Tags", cssClass: 'text-center', isBoolean: true,
        highlightValues: ['No'],
    },
    /*{attribute: "updatedOn", label: "Updated On", cssClass: 'text-center', isDate: true},*/
];

export const YES_NO_OPTIONS = [
    {key: 'Yes', label: 'Yes'},
    {key: 'No', label: 'No'},
];

export const BLOG_POST_STATUS_OPTIONS = [
    {key: 'Published', label: 'Published'},
    {key: 'Ready', label: 'Ready'},
    {key: 'Draft', label: 'Draft'},
    {key: 'New', label: 'New'},
    // {key: 'EMPTY', label: 'Empty'},
];

export const DESIGN_INFO_FILTER_ATTRIBUTES = ['productType', 'themeName', 'quoteName', 'category', 'parent'];

export const DEFAULT_DESIGN_INFO_FILTER_FIELD: any = {
    attribute: "productType",
    label: "Product Type",
    type: 'select',
    group: 'detail',
    cssClass: '',
    options: []
};

export const DESIGN_INFO_FILTER_FIELDS: any = [
    {
        attribute: "themeName",
        label: "Theme",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'quoteName'
    },
    {
        attribute: "quoteName",
        label: "Quote",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'themeName',
    },
    {
        attribute: "productType",
        label: "Product Type",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'category'
    },
    {
        attribute: "category",
        label: "Category",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'parent',
        dependsOn: 'productType',
    },
    {
        attribute: "parent",
        label: "Parent",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'category',
    },
    {
        attribute: "blogPost.status",
        label: "Blog Post Status",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: BLOG_POST_STATUS_OPTIONS
    },
    /*{
        attribute: "hasBlogPost",
        label: "Has Blog Post",
        type: 'checkbox',
        group: 'flags',
        cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasContent", label: "Has Content", type: 'checkbox', group: 'flags', cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasDuplicateMetaTitle",
        label: "Has Duplicate Meta Title",
        type: 'checkbox',
        group: 'flags',
        cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasTags", label: "Has Tags", type: 'checkbox', group: 'flags', cssClass: '',
        options: YES_NO_OPTIONS
    },*/
    {
        attribute: "hasBlogPost",
        label: "Has Blog Post",
        type: 'select',
        group: 'flags',
        cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasContent", label: "Has Content", type: 'select', group: 'flags', cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasDuplicateMetaTitle",
        label: "Has Duplicate Meta Title",
        type: 'select',
        group: 'flags',
        cssClass: '',
        options: YES_NO_OPTIONS
    },
    {
        attribute: "hasTags", label: "Has Tags", type: 'select', group: 'flags', cssClass: '',
        options: YES_NO_OPTIONS
    },
];

export const DESIGN_INFO_FILTER_FIELDS_FOR_PRODUCTS: any = [
    /*{
        attribute: "themeName",
        label: "Theme",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'quoteName'
    },
    {
        attribute: "quoteName",
        label: "Quote",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'themeName',
    },*/
    {
        attribute: "productType",
        label: "Product Type",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'category'
    },
    {
        attribute: "category",
        label: "Category",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'parent',
        dependsOn: 'productType',
    },
    /*{
        attribute: "parent",
        label: "Parent",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'category',
    }*/
];

export const DESIGN_PRODUCT_FIELDS_LIST: any = [
    {attribute: "name", label: "Name", cssClass: ''},
];

export const DESIGN_INFO_FILTER_FOR_SELECT_IMAGES_FIELDS: any = [
    {
        attribute: "themeName",
        label: "Theme",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'quoteName'
    },
    {
        attribute: "quoteName",
        label: "Quote",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'themeName',
    },
    {
        attribute: "productType",
        label: "Product Type",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'category'
    },
    {
        attribute: "category",
        label: "Category",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        childAttribute: 'parent',
        dependsOn: 'productType',
    },
    {
        attribute: "parent",
        label: "Parent",
        type: 'select',
        group: 'filter',
        cssClass: '',
        options: [],
        isDynamic: true,
        dependsOn: 'category',
    }
];
